// header search
(function() {
  const mq = window.matchMedia('(max-width: 1023px)');
  if (mq.matches) {
    const headerSearch = document.querySelector('.header__search');
    if (headerSearch) {
      headerSearch.remove();
    }
  } else {
    const headerSearchMobile = document.querySelector('.header-drawer__search');
    if (headerSearchMobile) {
      headerSearchMobile.remove();
    }
  }
})();

// initialize yotpo stars widgets on the product recommedations product cards
(function() {
  const productRecommendations = document.querySelector('product-recommendations.related-products');
  productRecommendations?.addEventListener('recommendations:loaded', () => {
    yotpoWidgetsContainer?.initWidgets();
  })
})();